import { render, staticRenderFns } from "./CookiesMain.vue?vue&type=template&id=d6d71f78&scoped=true"
import script from "./CookiesMain.vue?vue&type=script&lang=js"
export * from "./CookiesMain.vue?vue&type=script&lang=js"
import style0 from "./CookiesMain.vue?vue&type=style&index=0&id=d6d71f78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d71f78",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcookies-main%2FCookiesMain.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports